/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule5_CondInputs */

const tr_landing_pricerules_mock_rule5_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule5_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR %3 artarsa`)
};

const en_landing_pricerules_mock_rule5_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule5_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR rises 3%`)
};

const de_landing_pricerules_mock_rule5_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule5_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR steigt um 3%`)
};

const ru_landing_pricerules_mock_rule5_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule5_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR растет на 3%`)
};

/**
* | output |
* | --- |
* | "EUR rises 3%" |
*
* @param {Landing_Pricerules_Mock_Rule5_CondInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule5_cond = /** @type {((inputs?: Landing_Pricerules_Mock_Rule5_CondInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule5_CondInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule5_cond(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule5_cond(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule5_cond(inputs)
	return tr_landing_pricerules_mock_rule5_cond(inputs)
});